import {
  Anchor,
  Heading,
  Section,
  SubHeading,
  UnorderedList
} from '~/components/Prefabs';

export default function German() {
  return (
    <>
      <h1 className="text-center text-2xl font-bold md:text-4xl">
        Geschäftsbedingungen
      </h1>
      <Heading>1. Geltungsbereich & Allgemeine Informationen</Heading>
      <Section>
        <SubHeading>1.1 Über uns</SubHeading>
        <p>
          The Sole Supplier (im Folgenden „wir“, „uns“ oder „The Sole Supplier“)
          ist eine Affiliate-Marketing-Plattform, die Links zu Drittanbietern
          (im Folgenden „Händler“ oder „Partner“) bereitstellt. Wir verkaufen
          keine Produkte direkt, halten keinen Lagerbestand und verarbeiten
          keine Zahlungen. Stattdessen leiten wir Nutzer auf externe
          Händler-Websites weiter, auf denen Käufe abgeschlossen werden.
        </p>
        <SubHeading>1.2 Zustimmung zu den AGB</SubHeading>
        <p>
          Durch den Zugriff auf und die Nutzung der Website von The Sole
          Supplier („Website“) erklären Sie sich mit diesen Allgemeinen
          Geschäftsbedingungen („AGB“) einverstanden. Falls Sie diesen AGB nicht
          zustimmen, dürfen Sie unsere Website nicht nutzen.
        </p>
        <SubHeading>1.3 Affiliate-Partnerschaft & Transparenz</SubHeading>
        <p>
          The Sole Supplier nimmt an Affiliate-Marketing-Programmen teil. Wenn
          Sie auf einen Produktlink klicken, erhalten wir möglicherweise eine
          Provision, falls Sie über den Drittanbieter einen Kauf tätigen. Wir
          sind jedoch nicht für Bestellungen, Zahlungen, Versand oder
          Kundendienst verantwortlich.
        </p>
      </Section>
      <Section>
        <Heading>2. Art der Dienstleistungen & Haftungsausschluss</Heading>
        <SubHeading>2.1 Kein Direktverkauf</SubHeading>
        <p>
          The Sole Supplier verkauft keine Produkte direkt und ist nicht
          Vertragspartei von Kaufverträgen. Alle Bestellungen erfolgen direkt
          über die Händler-Websites.
        </p>
        <SubHeading>2.2 Richtigkeit der Produktinformationen</SubHeading>
        <p>
          Wir bemühen uns, Produktbeschreibungen, Preise und Verfügbarkeiten
          aktuell zu halten. Diese Informationen werden jedoch von
          Drittanbietern bereitgestellt und können sich jederzeit ändern. Wir
          übernehmen keine Gewähr für die Richtigkeit der Angaben.
        </p>
        <SubHeading>2.3 Keine Verantwortung für Käufe</SubHeading>
        <p>
          Da alle Bestellungen direkt über Drittanbieter erfolgen, übernehmen
          wir keine Haftung für:
        </p>
        <UnorderedList>
          <li>Bestellabwicklung oder Zahlungstransaktionen</li>
          <li>Versand, Lieferung oder Zollgebühren</li>
          <li>Rücksendungen, Erstattungen oder Umtausch</li>
          <li>Produktqualität, Garantie oder Defekte</li>
        </UnorderedList>
        <p>
          Für alle Fragen zu Ihrem Kauf wenden Sie sich bitte direkt an den
          Händler.
        </p>
      </Section>
      <Section>
        <Heading>3. Nutzerpflichten & zulässige Nutzung</Heading>
        <SubHeading>3.1 Kontoerstellung</SubHeading>
        <p>
          Für bestimmte Funktionen auf unserer Website kann eine Kontoerstellung
          erforderlich sein. Sie sind verpflichtet, wahrheitsgemäße Angaben zu
          machen und Ihre Anmeldedaten sicher zu verwahren.
        </p>
        <SubHeading>3.2 Verbotene Aktivitäten</SubHeading>
        <p>Sie dürfen unsere Website nicht nutzen für:</p>
        <UnorderedList>
          <li>Betrügerische oder rechtswidrige Zwecke</li>
          <li>Das Verbreiten falscher oder irreführender Informationen</li>
          <li>Automatisierte Zugriffe (z. B. durch Bots oder Scraper)</li>
          <li>Verstöße gegen geltendes Recht</li>
        </UnorderedList>
        <p>
          Wir behalten uns das Recht vor, Konten bei Verstößen gegen diese AGB
          zu sperren oder zu löschen.
        </p>
      </Section>
      <Section>
        <Heading>4. Datenschutz & DSGVO (DSGVO/BDSG-Konformität)</Heading>
        <SubHeading>4.1 Einhaltung der DSGVO</SubHeading>
        <p>
          The Sole Supplier verarbeitet personenbezogene Daten gemäß der
          Datenschutz-Grundverordnung (DSGVO) und dem Bundesdatenschutzgesetz
          (BDSG). Weitere Informationen finden Sie in unserer{' '}
          <Anchor href="https://products.privasee.io/privacy-portal/64ac2c059f43880013f2faf0">
            Datenschutzerklärung
          </Anchor>
          .
        </p>
        <SubHeading>4.2 Ihre Rechte gemäß DSGVO</SubHeading>
        <p>Sie haben das Recht auf:</p>
        <UnorderedList>
          <li>Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)</li>
          <li>Berichtigung fehlerhafter Daten (Art. 16 DSGVO)</li>
          <li>
            Löschung Ihrer Daten („Recht auf Vergessenwerden“) (Art. 17 DSGVO)
          </li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
        </UnorderedList>
        <p>
          Zur Ausübung dieser Rechte kontaktieren Sie uns unter{' '}
          <Anchor href="mailto:compliance@thesolesupplier.co.uk">
            compliance@thesolesupplier.co.uk
          </Anchor>
          .
        </p>
        <SubHeading>4.3 Cookies & Tracking</SubHeading>
        <p>
          Wir verwenden Cookies, um die Nutzung unserer Website zu analysieren
          und zu verbessern. Nicht essenzielle Cookies (z. B. für Marketing und
          Analysen) erfordern Ihre ausdrückliche Zustimmung. Sie können Ihre
          Cookie-Einstellungen jederzeit in Ihrem Browser anpassen.
        </p>
      </Section>
      <Section>
        <Heading>5. Anwendbares Recht & Verbraucherschutz (BGB & UWG)</Heading>
        <SubHeading>5.1 Geltendes Recht & Gerichtsstand</SubHeading>
        <p>
          Diese AGB unterliegen deutschem Recht, unter Ausschluss des
          UN-Kaufrechts (CISG).
        </p>
        <SubHeading>5.2 Verbraucherrechte in Deutschland</SubHeading>
        <p>
          Da The Sole Supplier selbst keine Produkte verkauft, gelten
          Verbraucherrechte wie Widerruf und Gewährleistung nur für Käufe direkt
          bei Händlern. Unsere Partnerhändler müssen sich an:
        </p>
        <UnorderedList>
          <li>
            Das 14-tägige Widerrufsrecht (§ 355 BGB, Fernabsatzgesetz) halten.
          </li>
          <li>
            Die gesetzliche Gewährleistung von 2 Jahren (§ 437 BGB) für defekte
            Produkte einhalten.
          </li>
        </UnorderedList>
        <p>
          Für Rücksendungen oder Erstattungen wenden Sie sich bitte an den
          jeweiligen Händler.
        </p>
      </Section>
      <Section>
        <Heading>6. Haftungsausschluss & Begrenzung</Heading>
        <SubHeading>6.1 Ausschluss der Haftung</SubHeading>
        <p>The Sole Supplier ist nicht verantwortlich für:</p>
        <UnorderedList>
          <li>Fehlerhafte Produktinformationen oder Preisangaben</li>
          <li>Probleme mit Produktverfügbarkeit oder Lieferung</li>
          <li>Finanzielle Schäden aus Transaktionen mit Dritten</li>
          <li>
            Technische Fehler oder temporäre Nichtverfügbarkeit der Website
          </li>
        </UnorderedList>
        <SubHeading>6.2 Affiliate-Provisions-Offenlegung</SubHeading>
        <p>
          Wir erhalten möglicherweise eine Provision für über unsere Website
          getätigte Käufe. Dies hat keinen Einfluss auf den Produktpreis.
        </p>
      </Section>
      <Section>
        <Heading>
          7. Impressum (Gesetzliche Anbieterkennzeichnung – §5 TMG)
        </Heading>
        <p>
          The Sole Supplier Ltd.
          <br />
          Ckr House 70 East Hill, Dartford, Kent, DA1 1RZ
          <br />
          Geschäftsführer: George Sullivan
          <br />
          Handelsregister: 09098756 <br />
          Umsatzsteuer-ID: 220675526
          <br />
          E-Mail:{' '}
          <Anchor href="mailto:compliance@thesolesupplier.co.uk">
            compliance@thesolesupplier.co.uk
          </Anchor>
        </p>
        <p>Telefon: +44 7752294349</p>
        <p>
          Für rechtliche Anfragen kontaktieren Sie uns unter{' '}
          <Anchor href="mailto:compliance@thesolesupplier.co.uk">
            compliance@thesolesupplier.co.uk
          </Anchor>
        </p>
      </Section>
      <Section>
        <Heading>8. Änderungen der AGB</Heading>
        <p>
          Wir behalten uns das Recht vor, diese AGB jederzeit zu ändern. Nutzer
          werden über wesentliche Änderungen per E-Mail oder durch eine
          Mitteilung auf unserer Website informiert.
        </p>
      </Section>
    </>
  );
}
